import React from "react";
import { NavLink, Link } from "react-router-dom";
import PropTypes from "prop-types";
import Icon from "./Icon";
import "../css/Navbar.css";
import Headroom from "headroom.js";
import LogoWhite from "../images/PQR_Beton_logo_fond_blanc.svg";
import LogoBlack from "../images/PQR_Beton_logo_fond_blanc.svg";

/**
 * Navbar Component
 */
class Navbar extends React.Component {
  static displayName = "Navbar";
  static propTypes = {
    className: PropTypes.string,
    stores: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
    isHome: PropTypes.bool,
  };
  static defaultProps = {
    isHome: false,
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Navbar";

    this.state = {
      top: false,
      showOverlay: false,
    };
  }

  /**
   * @override
   */
  componentDidMount() {
    if (this.props.isHome) {
      const options = {
        onTop: () => this.setState({ top: true }),
        onNotTop: () => this.setState({ top: false }),
      };
      const headroom = new Headroom(this.navbar, options);
      headroom.init();
    }
  }

  /**
   * @override
   */
  render() {
    const navShortcuts = this.props.stores.page.navShortcuts;
    // Avoid body scroll
    if (this.state.showOverlay)
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    else document.getElementsByTagName("body")[0].style.overflow = "auto";
    console.log({ navigation: this.props.stores.page.navigation.toJS() });
    return (
      <div
        className={`${this.className} ${this.props.className || ""}
        ${this.state.top ? "top" : "not-top"}
        ${this.state.showOverlay ? "overlay" : ""}`}
        ref={(n) => (this.navbar = n)}
      >
        <div className={`${this.className}__main`}>
          <a className={`${this.className}__logo`} href="/">
            <img src={this.state.top ? LogoBlack : LogoWhite} alt="logo" />
          </a>
          <div
            className={`${this.className}__menu`}
            onClick={() =>
              this.setState({ showOverlay: !this.state.showOverlay })
            }
          >
            <Icon icon={this.state.showOverlay ? "close" : "menu"} />
          </div>
          {this.props.screen === "mobile" && this.state.showOverlay && (
            <ul className={`${this.className}__overlay`}>
              {this.props.stores.page.navigation
                .filter((navigation) => navigation.ShowInMenus)
                .map((navigation) => {
                  if (navigation.url !== "/")
                    return (
                      <li key={navigation.id}>
                        <Link
                          to={navigation.url}
                          onClick={() => this.setState({ showOverlay: false })}
                        >
                          {navigation.Icon && (
                            <img
                              src={navigation.Icon}
                              alt="icon"
                              className={`${this.className}__navlink_icon ${this.className}__navlink_icon--mobile`}
                            />
                          )}
                          {navigation.name}
                        </Link>
                      </li>
                    );
                  return null;
                })}
            </ul>
          )}
          <div className={`${this.className}__lks`}>
            <Link
              className={`${this.className}__lk`}
              to={navShortcuts.first().url}
            >
              Demander une offre
              <span
                className={
                  "icon" +
                  (this.state.top ? " is-right is-light" : " is-right is-dark")
                }
              />
            </Link>
            <a
              className={`${this.className}__lk`}
              target="_blank"
              rel="noopener noreferrer"
              href={navShortcuts.last().url}
            >
              Liste de prix
              <span
                className={
                  "icon" +
                  (this.props.screen === "mobile"
                    ? this.state.top
                      ? " is-right is-light"
                      : " is-right is-dark"
                    : this.state.top
                    ? " is-dl is-light"
                    : " is-dl is-dark")
                }
                style={
                  this.props.screen === "mobile" ? {} : { width: "0.6rem" }
                }
              />
            </a>
          </div>
        </div>
        {this.props.screen === "desktop" && (
          <div className={`${this.className}__navlinks`}>
            {this.props.stores.page.navigation
              .filter((navigation) => navigation.ShowInMenus)
              .map((navigation) => {
                if (navigation.url !== "/")
                  return (
                    <NavLink
                      to={navigation.url}
                      className={`${this.className}__navlink`}
                      activeClassName="active"
                      key={navigation.id}
                      exact
                    >
                      {navigation.Icon && (
                        <img
                          src={navigation.Icon}
                          alt="icon"
                          className={`${this.className}__navlink_icon`}
                        />
                      )}
                      {navigation.name}
                    </NavLink>
                  );
                return null;
              })}
          </div>
        )}
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js